
export default {
  productData: {
    serialNumber: 'DA-MME-009',
    name: 'Massivholzdecke mit Estrich l Aufbau 9',
    construction: {
      composition: [
        {
          type: 'screed',
          title: { de: 'Estrich' },
          output: '≥ 60',
          value: 'w-60'
        },
        {
          type: 'insulation',
          title: { de: 'Mineralwolldämmplatte MW<br>(<i>s‘</i> ≤ 8 MN/m<sup>3</sup>; Anwendungsgebiet DES-sh)' },
          output: '≥ 30',
          value: 'm-30'
        },
        {
          type: 'fill',
          title: { de: 'Ungebundener Splitt<br>(<i>m‘</i> ≥ 94,4 kg/m<sup>2</sup>)' },
          output: '≥ 65',
          value: 'us-65'
        },
        {
          type: 'supportingStructure',
          title: { de: 'Brettsperrholzdecke' },
          output: 120,
          value: 'bsh-120'
        }
      ],
      sum: {
        output: '275', value: 275
      }
    },
    technicalValues: {
      impactSoundLevel: { // L,nw
        output: '45 (-3; 8)',
        value: 45
      },
      soundReductionIndex: { // Rw
        output: '77 (-1; -6)',
        value: 77
      },
      heatTransferCoefficient: { // U-Wert
        output: '0,44',
        value: 0.44
      },
      fireResistance: {
        output: 'F 30-B',
        value: 'F-30-B'
      },
      massPerUnitArea: {
        output: '304 [kg/m²]'
      }
    }
  },
  image: 'da-mme-009.svg',
  pdf: 'Massivholzdecke-mit-Estrich-Aufbau-9-DA-MME-009-Rev01.pdf'
}
